(() => {
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('main-cart::refresh'));
      document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
      document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));;
    }, 2000);
    
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('main-cart::refresh'));
      document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
      document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
    }, 4500);
  }
  
  document.addEventListener('click', function(event) {
    if (event.target.closest('.js-plus') || event.target.closest('.js-minus') || event.target.closest('.main-cart__line-item__remove')) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('main-cart::refresh'));
        document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
        document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
      }, 1500);
      
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('main-cart::refresh'));
        document.dispatchEvent(new CustomEvent('cart::add', { detail: {} }));
        document.dispatchEvent(new CustomEvent('cart::update', { detail: {} }));
      }, 3500);
    }
  });
})();